import React from 'react'
import { Field } from '@pbt/pbt-ui-components'

import { RetailOrderLineItem } from '~/api/graphql/generated/types'

import ChargeDetailsCurrencyField from './ChargeDetailsCurrencyField'

export interface ChargeFieldRetailDeliveryFeeProps {
  className?: string
  inputClassName?: string
  item: RetailOrderLineItem
  retailDeliveryFeeField: Field
}

const ChargeFieldRetailDeliveryFee = ({
  className: classNameProp,
  inputClassName,
  item,
  retailDeliveryFeeField,
}: ChargeFieldRetailDeliveryFeeProps) => (
  <ChargeDetailsCurrencyField
    disabled
    className={classNameProp}
    field={retailDeliveryFeeField}
    inputClassName={inputClassName}
    item={item}
  />
)

export default ChargeFieldRetailDeliveryFee
